




/** @format */
/**创建一个钉钉中转页面 */

import { Vue, Component } from 'vue-property-decorator'
import AuthApi from '@/api/auth'

@Component
export default class extends Vue {
	created() {
		let { code, authCode, state, loginStatus } = this.$route.query
		console.log('this.$route.query', this.$route.query)

		code = code || authCode
		loginStatus = loginStatus || '3' // 登录状态 1 旧版扫码,没传就1 2 免登录 3 新扫码

		const params = {
			code,
			loginStatus,
			state,
		}

		this.loginByDd(params)
	}

	private async loginByDd(params: any) {
		const res = await this.$store.dispatch('user/ddLogin', params)
		if (res.code === 200) {
			await this.$store.dispatch('user/getUserInfo')
			this.$router.replace(
				'/',
				() => {},
				() => {}
			) // 防报错 TODO
		} else {
			window.location.replace(`${location.origin}/passport/login`)
		}
	}
}
